import React, { useState, useRef } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { Button, UploadPhoto } from 'common/commonIndex';

const ImageCropper = ({ defaultProfileIcon, cameraIcon, setUploadImg, formData, className, addStoryIcon, isProfilePage, isCropTool, setIsCropTool }) => {
  const [upImg, setUpImg] = useState(null);
  const cropperRef = useRef(null);

  const uploadUserPhoto = (data) => {
    setTimeout(() => {
      getCroppedImage();
    }, 500);
    setUpImg(data);
    if (isProfilePage) {
      setIsCropTool(true);
    }
  };

  const getCroppedImage = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const croppedCanvas = cropper.getCroppedCanvas({
        width: 100,  // Desired width of the cropped image
        height: 100, // Desired height of the cropped image
        fillColor: '#fff', // Background color for transparency
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      });
      croppedCanvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], 'croppedImage.jpg', { type: 'image/jpeg' });
          setUploadImg(file);  // Pass the file object instead of URL
          formData['profile'] = file;
        }
      }, 'image/jpeg');
    }
  };

  const showImg = (upImg) => {
    if (upImg && upImg !== '') {
      return URL.createObjectURL(upImg);
    } else {
      return null;
    }
  };

  return (
    <div className={`App ${className ? className + ` row` : ''}`}>
      <div className={className ? 'col-md-4' : ''}>
        <UploadPhoto
          formData={formData}
          defaultProfileIcon={defaultProfileIcon}
          cameraIcon={cameraIcon}
          previewUrl={showImg(upImg)}
          type={'profile'}
          addStoryIcon={addStoryIcon}
          uploadUserPhoto={uploadUserPhoto}
        />
      </div>

      {isProfilePage ? isCropTool && upImg && (
        <div className={`d-flex justify-content-center align-items-center ${className ? 'col-md-8' : ''}`}>
          <Cropper
            ref={cropperRef}
            src={showImg(upImg)}
            preview=".img-preview"
            style={{ height: 160, width: "230px" }}
            aspectRatio={1}  // Make the crop area square
            initialAspectRatio={3 / 2}
            guides={false}   // Disable the guides
            cropBoxResizable={false} // Disable resizing the crop box
            cropBoxMovable={true}  // Enable moving the crop box
            circularCrop={true}   // Make the crop box circular
            responsive={true}
            background={false}
            checkOrientation={false}  // Fix for image orientation issues
            minCropBoxHeight={10}
            minCropBoxWidth={10}
          />
          <Button
            btnClass={'btn-primary question-btn ms-3'}
            btnType={'button'}
            btnName={'Crop'}
            onClick={getCroppedImage}
            isDisabled={true}
          />
        </div>
      ) : upImg && (
        <div className={`d-flex justify-content-center align-items-center ${className ? 'col-md-8' : ''}`}>
          <Cropper
            ref={cropperRef}
            src={showImg(upImg)}
            preview=".img-preview"
            style={{ height: 160, width: "230px" }}
            aspectRatio={1}  // Make the crop area square
            initialAspectRatio={3 / 2}
            guides={false}   // Disable the guides
            cropBoxResizable={false} // Disable resizing the crop box
            cropBoxMovable={true}  // Enable moving the crop box
            circularCrop={true}   // Make the crop box circular
            responsive={true}
            background={false}
            checkOrientation={false}  // Fix for image orientation issues
            minCropBoxHeight={10}
            minCropBoxWidth={10}
          />
          <Button
            btnClass={'btn-primary question-btn ms-3'}
            btnType={'button'}
            btnName={'Crop'}
            onClick={getCroppedImage}
            isDisabled={true}
          />
        </div>
      )}
    </div>
  );
};

ImageCropper.defaultProps = {
  onImageCropped: () => { },
};

export default ImageCropper;
